<template>
  <b-modal id="bv-modal-edit-paragraph" size="lg" hide-footer centered>
    <template v-slot:modal-title>
      Edit Paragraph
    </template>
    <b-form @submit.prevent="editParagraph">

      <b-form-group
        id="paragraph-title-group"
        label="Paragraph Title"
        label-for="paragraph-title"
      >
        <b-form-input
          id="paragraph-title"
          v-model="editForm.title"
          type="text"
          required
          placeholder="Enter a title"
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary"><b-spinner small variant="light" v-if="isLoading"></b-spinner> Edit</b-button> 
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

import {
  MONITOR_PARAGRAPH_EDIT
} from "@/store/actions.type";

export default {
  name: 'MonitorParagraphEdit',
  props: ['paragraph'],
  data() {
    return {
      editForm: {
        title: ''
      },
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCurrent"])
  },
  methods: {
    editParagraph() {
      this.isLoading = true;

      let paragraphData = new FormData();
      paragraphData.set('name', this.editForm.title);

      let payload = {
        chapterId: this.paragraph.chapter,
        paragraphId: this.paragraph.id,
        paragraphData: paragraphData
      }

      this.$store.dispatch(MONITOR_PARAGRAPH_EDIT, payload).then(() => {
        this.$bvModal.hide('bv-modal-edit-paragraph');
        this.$bvToast.toast(`Paragraph ${this.editForm.title} has been edited successfully`, {
          title: 'Paragraph edited',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.resetForm();
        this.isLoading = false;
        this.$emit('paragraphEdited');
      });
    },
    resetForm() {
      this.editForm.title = '';
    }
  },
  watch: {
    paragraph: function() {
      this.editForm.title = this.paragraph.name;
    }
  }
}
</script>